import { getJSON, postJSON } from 'common/services/api'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import {
  INVOICING_SETTINGS_QUERY_KEY,
  INVOICING_SETTINGS_UPDATE_QUERY_KEY,
  INVOICING_SETTINGS_URL
} from './queryConstants'

export interface InvoicingSettings {
  enabled: boolean
}

export const useGetInvoicingSettings = (enabled = true) => {
  return useQuery<InvoicingSettings>(
    [INVOICING_SETTINGS_QUERY_KEY],
    async () => {
      const response = await getJSON({
        url: INVOICING_SETTINGS_URL,
        isRota: true
      })
      return response ?? { enabled: false }
    },
    { enabled, staleTime: 30_000, refetchOnWindowFocus: false }
  )
}

export const useUpdateInvoicingSettings = () => {
  const queryClient = useQueryClient()

  const updateFunction = async (dto: InvoicingSettings): Promise<void> => {
    await postJSON({
      url: INVOICING_SETTINGS_URL,
      method: 'PUT',
      json: dto,
      isRota: true,
      responseType: 'text'
    })
  }

  const { mutateAsync: updateInvoicingSettings, isLoading: isUpdating } =
    useMutation<void, unknown, InvoicingSettings, unknown>(
      [INVOICING_SETTINGS_UPDATE_QUERY_KEY],
      updateFunction,
      {
        onSuccess: () => {
          queryClient.invalidateQueries([INVOICING_SETTINGS_QUERY_KEY])
        }
      }
    )

  return { updateInvoicingSettings, isUpdating }
}
